import React, { Component } from "react";
import PropTypes from "prop-types";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import * as AnnotationsModule from "highcharts/modules/annotations";
import { isMobileDevice, convertToCurrencyFormat } from "../../helpers/Utils";
import moment from "moment";
import StyleConstants from "../../shared/constants/styleConstants/styles.json";

AnnotationsModule(Highcharts);

const dateRange = [
  { label: "Day", value: 1 },
  { label: "Week", value: 7 },
  { label: "Month", value: 30 },
];

const IS_MOBILE = isMobileDevice();

class LineChart extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedDateRangeIndex: IS_MOBILE ? 1 : 0 };
  }

  addMissingDataPoints(rawGraphData) {
    var dataPoints = Object.keys(rawGraphData);
    var missingDates = dataPoints
      .sort(function (a, b) {
        return Date.parse(a) - Date.parse(b);
      })
      .reduce(
        (function (hash) {
          return function (p, c) {
            var missingDaysNo =
              (Date.parse(c) - hash.prev) / (1000 * 3600 * 24);
            if (hash.prev && missingDaysNo > 1) {
              for (var i = 1; i < missingDaysNo; i++)
                p.push(moment(hash.prev).add(i, "days").format("YYYY-MM-DD"));
            }
            hash.prev = Date.parse(c);
            return p;
          };
        })(Object.create(null)),
        []
      );
    for (var j = 0; j < missingDates.length; j++) {
      dataPoints.push(missingDates[j]);
    }
    dataPoints.sort(function (a, b) {
      return Date.parse(a) - Date.parse(b);
    });
    var dashData = {};
    dataPoints.map((point) => {
      dashData[point] = rawGraphData[point] || 0;
    });
    return dashData;
  }

  filterByRange(graphData) {
    const { selectedDateRangeIndex } = this.state;
    let filteredData = {};
    var dataPoints = Object.keys(graphData);

    if (
      dateRange[selectedDateRangeIndex].label === "Week" ||
      dateRange[selectedDateRangeIndex].label === "Day"
    ) {
      for (
        let i = 0;
        i < dataPoints.length;
        i = i + dateRange[selectedDateRangeIndex].value
      ) {
        let count = 0;
        let j_value = 0;
        for (
          let j = 0;
          j < dateRange[selectedDateRangeIndex].value &&
          j + i < dataPoints.length;
          j++
        ) {
          j_value = j;
          count = count + parseInt(graphData[dataPoints[j + i]], 10);
        }
        filteredData[moment(dataPoints[j_value + i]).format("DD MMM YY")] =
          count;
      }
    } else {
      for (let i = 0; i < dataPoints.length; i = i + 1) {
        let month = moment(dataPoints[i]).format("MMM YYYY");
        if (filteredData[month]) {
          filteredData[month] =
            filteredData[month] + parseInt(graphData[dataPoints[i]], 10);
        } else {
          filteredData[month] = parseInt(graphData[dataPoints[i]], 10);
        }
      }
    }

    dataPoints = Object.keys(filteredData);
    if (dateRange[selectedDateRangeIndex].label === "Week") {
      dataPoints.map((data) => {
        if (moment(data) < moment().subtract(16, "weeks")) {
          delete filteredData[data];
        }
      });
    } else if (dateRange[selectedDateRangeIndex].label === "Day") {
      dataPoints.map((data) => {
        if (moment(data) < moment().subtract(60, "days")) {
          delete filteredData[data];
        }
      });
    } else {
      dataPoints.map((data) => {
        if (moment(data) < moment().subtract(12, "months")) {
          delete filteredData[data];
        }
      });
    }

    return filteredData;
  }

  setOptions(graphData) {
    const { xAxisLabel, yAxisLabel, chartType } = this.props;
    const options = {
      title: { text: "" },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      chart: {
        backgroundColor: "white",
        style: {
          width: "inherit",
          height: 400,
          fontSize: 16,
          fontFamily: "'Poppins', sans-serif",
        },
      },
      tooltip: {
        formatter() {
          let date = this.x;
          Object.keys(graphData).map((data) => {
            if (data.startsWith(this.x)) {
              date = data;
            }
          });
          return `<div><b>${convertToCurrencyFormat(
            this.y
          )}</b><br/><b>${date}</b></div>`;
        },
      },
      xAxis: {
        title: { text: xAxisLabel, margin: 10 },
        categories: Object.keys(graphData).map((data) => {
          return data.split(",")[0];
        }),
      },
      yAxis: {
        title: { text: yAxisLabel, margin: 20 },
        labels: {
          formatter() {
            return convertToCurrencyFormat(this.value, "");
          },
        },
      },
      type: chartType,
      series: [
        {
          type: chartType,
          color: StyleConstants.color.darkBlue,
          data: Object.values(graphData),
        },
      ],
    };
    return options;
  }

  renderGraph() {
    const { selectedDateRangeIndex } = this.state;
    const { rawGraphData } = this.props;
    const graphData = this.addMissingDataPoints(rawGraphData);
    const filteredGraphData = this.filterByRange(graphData);
    const options = this.setOptions(filteredGraphData);
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: 0,
          width: "100%",
          backgroundColor: "white",
          marginTop: 5,
          marginBottom: 30,
          justifyContent: "center",
          height: "max-content",
          borderRadius: 10,
          boxShadow: "1px 2px 6px #8b9daf26",
        }}
      >
        <div
          style={{
            display: "flex",
            margin: IS_MOBILE ? 30 : "30px 30px 0 0",
            justifyContent: IS_MOBILE ? "center" : "flex-end",
          }}
        >
          {dateRange.map((range, index) => {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "gray",
                  backgroundColor:
                    selectedDateRangeIndex === index ? "#e6e3e3" : "white",
                  padding: "5px 10px",
                  border: "1px solid lightgray",
                  marginLeft: 20,
                  textAlign: "center",
                  width: 68,
                  cursor: "pointer",
                  borderRadius: 6,
                  fontFamily: "'Poppins', sans-serif",
                }}
                onClick={() => {
                  this.setState({ selectedDateRangeIndex: index });
                }}
              >
                {range.label}
              </div>
            );
          })}
        </div>
        <div
          style={{
            margin: IS_MOBILE ? "0 10px 0 0" : "20px 30px 20px 20px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <HighchartsReact
            highcharts={Highcharts}
            options={options}
            style={{ zIndex: 0 }}
          />
        </div>
      </div>
    );
  }

  render() {
    return <>{this.renderGraph()}</>;
  }
}

LineChart.propTypes = {
  rawGraphData: PropTypes.object,
  xAxisLabel: PropTypes.string,
  yAxisLabel: PropTypes.string,
  chartType: PropTypes.string,
};

LineChart.defaultProps = {
  xAxisLabel: "",
  yAxisLabel: "",
  chartType: "",
};

export default LineChart;
